export default "__VITE_ASSET__c83034e5__"